const TopicsUtil =  {
    topics:{},
    initing:false,
    getTopics:function (learnLanguage,nativeLanguage,setTopics) {
        if(learnLanguage === '' || nativeLanguage === '')
          return;
        let filename = "topics_en"
        if (learnLanguage === 'Chinese') {
            if (nativeLanguage === 'Vietnamese') {
              filename = "topics_cn_vn";
            } else {
              filename = "topics_cn";
            }
          } else {
            if (nativeLanguage === 'Vietnamese') {
              filename = "topics_en_vn";
            } else {
              filename = "topics_en";
            }
         }

        console.log("asasdsad: ", learnLanguage, nativeLanguage)
        
        if(this.initing){
            return ;//this.topics;
        }
        
        // console.log("topics : " + this.topics + "  " + JSON.stringify(this.topics))
        if(!JSON.stringify(this.topics) === '{}'){
            //console.log("topics1 : " + this.topics)
            return ;// this.topics;
        }    
        // console.log("learnLanguage: " + learnLanguage);
        this.initing = true;
        
        //fetch(`http://127.0.0.1:8000/json/${filename}.json`) // local dev mode
        fetch(`/json/${filename}.json`) //production mode
            .then(res => res.json())
            .then(out => {
                // console.log("out::: " + JSON.stringify(out));
                this.topics = out;
                setTopics(out);
                // console.log("topics2 : " + JSON.stringify(this.topics))
                this.initing = false;
                return ;//out;
               
            })
        .catch(err => {console.log("error::: " + err);throw err;} );   

        return ;//this.topics;
    }

}

export default TopicsUtil;